import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const ContactSection = () => {
  return (
    <Box
      id="contact"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        position: 'relative',
        backgroundColor: '#1A1A1A',
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), url(/img/23.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        px: { xs: 4, md: 8, lg: 12 },
        py: 8,
      }}
    >
      {/* <Box sx={{ position: 'absolute', top: { xs: 30, md: 50 }, left: { xs: 30, md: 50 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: { xs: 50, md: 70 },
              height: { xs: 50, md: 70 },
              borderRadius: '50%',
              backgroundColor: '#2858A8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '3px solid #5B8BC9',
            }}
          >
            <Box
              sx={{
                fontFamily: 'serif',
                fontSize: { xs: '24px', md: '32px' },
                fontWeight: 700,
                color: '#FFFFFF',
              }}
            >
              अ
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                fontFamily: 'Oswald',
                fontSize: { xs: '16px', md: '20px' },
                fontWeight: 500,
                color: '#FFFFFF',
                lineHeight: 1.2,
              }}
            >
              Arvira
            </Box>
            <Box
              sx={{
                fontFamily: 'Oswald',
                fontSize: { xs: '16px', md: '20px' },
                fontWeight: 500,
                color: '#FFFFFF',
                lineHeight: 1.2,
              }}
            >
              Creations
            </Box>
          </Box>
        </Box>
      </Box> */}

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Box sx={{ mt: { xs: 15, md: 8 } }}>
          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: { xs: '64px', sm: '96px', md: '128px', lg: '160px' },
              fontWeight: 700,
              color: '#FFFFFF',
              letterSpacing: '0.05em',
              lineHeight: 0.9,
              mb: 1,
            }}
          >
            CONTACT
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: { xs: '64px', sm: '96px', md: '128px', lg: '160px' },
              fontWeight: 700,
              color: '#A8C5E8',
              letterSpacing: '0.05em',
              lineHeight: 0.9,
              mb: 6,
            }}
          >
            US FOR MORE
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '12px', md: '14px' },
              fontWeight: 300,
              color: '#D4C5B0',
              letterSpacing: '0.3em',
              mb: 2,
            }}
          >
            AT
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '20px', md: '26px', lg: '30px' },
              fontWeight: 400,
              color: '#FFFFFF',
              letterSpacing: '0.05em',
              mb: 2,
            }}
          >
            +919432283366, +919432168999
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '12px', md: '14px' },
              fontWeight: 300,
              color: '#D4C5B0',
              letterSpacing: '0.3em',
              mb: 2,
            }}
          >
            OR
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '16px', md: '20px', lg: '22px' },
              fontWeight: 400,
              color: '#FFFFFF',
              letterSpacing: '0.03em',
              mb: 4,
            }}
          >
            arviracreation@outlook.com
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '14px', md: '16px' },
              fontWeight: 300,
              color: '#D4C5B0',
              letterSpacing: '0.1em',
            }}
          >
            
          </Typography>
        </Box>
      </motion.div>
    </Box>
  );
};

export default ContactSection;
